export function toDateInputValue(date: Date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function formatMoneyBRL(value: number) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '-';
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

